export const EMPTY_CART = 'EMPTY_CART';
